import { ONMYWAY_PLATFORM_FEATURES } from "./onmywayFeatures";

/**
 * Maps API / dashboard feature keys to official OnMyWay names — https://onmyway.com
 */
const FEATURE_KEY_TO_DISPLAY_NAME: Record<string, string> = {
  SecurePath: "Archie+ SecurePath™",
  securePath: "Archie+ SecurePath™",
  secure_path: "Archie+ SecurePath™",
  is_secure: "Archie+ SecurePath™",
  is_secure_enable: "Archie+ SecurePath™",

  "Rideshare RideWatch": "Rideshare RideWatch™",
  RideWatch: "Rideshare RideWatch™",
  rideWatch: "Rideshare RideWatch™",
  is_ride_enable: "Rideshare RideWatch™",

  OnMyWayDrive: "OnMyWay Drive™",
  "OnMyWay Drive": "OnMyWay Drive™",
  onMyWayDrive: "OnMyWay Drive™",
  distractedDriving: "OnMyWay Drive™",

  VerifyAI: "VerifyAI™",
  verifyAI: "VerifyAI™",
  is_ai_anlysis_enable: "VerifyAI™",
  is_crime_enable: "VerifyAI™",

  "Mental Health": "Mental Health Shield™",
  MentalHealth: "Mental Health Shield™",
  mentalHealth: "Mental Health Shield™",
  is_medical: "Mental Health Shield™",
  is_medical_enable: "Mental Health Shield™",

  "Archie+ Personal Assistant": "Archie+ Personal Assistant™",
  PersonalVoiceAssistant: "Archie+ Personal Assistant™",
  is_personal_voice_assistant_enable: "Archie+ Personal Assistant™",

  "Safety In-Motion": "Safety In-Motion™",
  SafetyInMotion: "Safety In-Motion™",
  safetyInMotion: "Safety In-Motion™",
  is_safety_motion_enable: "Safety In-Motion™",
  noonlightAlert: "Safety In-Motion™",
  noonlight_alert: "Safety In-Motion™",

  "Lone-Worker": "Remote-Worker Lifeline™",
  LoneWorker: "Remote-Worker Lifeline™",
  loneWorker: "Remote-Worker Lifeline™",
  lone_worker: "Remote-Worker Lifeline™",
  is_loneworker: "Remote-Worker Lifeline™",
  is_loneworker_enable: "Remote-Worker Lifeline™",

  "Workplace Emergency": "Workplace Emergency Program™",
  WorkplaceEmergency: "Workplace Emergency Program™",
  workplaceEmergency: "Workplace Emergency Program™",
  is_workplace_emergency_enable: "Workplace Emergency Program™",

  OnMyWayIncentives: "OnMyWay Incentives™",
  "OnMyWay Incentives": "OnMyWay Incentives™",
  safetyIncentives: "OnMyWay Incentives™",
};

const normalizeKey = (key: string): string =>
  key.toLowerCase().replace(/[^a-z0-9]/g, "");

const NORMALIZED_LOOKUP = Object.fromEntries(
  Object.entries(FEATURE_KEY_TO_DISPLAY_NAME).map(([key, name]) => [
    normalizeKey(key),
    name,
  ])
);

const stripTm = (name: string): string => name.replace(/™/g, "").trim();

/** Official feature names for empty-state / fallback list on dashboard */
export const DASHBOARD_FEATURE_FALLBACK = ONMYWAY_PLATFORM_FEATURES.map(
  (feature) => ({
    key: feature.id,
    name: stripTm(feature.name),
    value: 0,
  })
);

export const getFeatureDisplayName = (apiKey: string): string => {
  let name = apiKey;
  if (FEATURE_KEY_TO_DISPLAY_NAME[apiKey]) {
    name = FEATURE_KEY_TO_DISPLAY_NAME[apiKey];
  } else {
    const normalized = normalizeKey(apiKey);
    if (NORMALIZED_LOOKUP[normalized]) {
      name = NORMALIZED_LOOKUP[normalized];
    }
  }
  return stripTm(name);
};
